import React, { useState, useCallback, useMemo } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import "../../../../Utils/Css/Menu.css";

export default function Menu({
  trade_search,
  handlewSort,
  trade_delete,
  userType,
}) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  // 🔹 Memoize for better performance
  const sortedData = useCallback(
    (key, direction) => {
      if (!Array.isArray(trade_search)) return trade_search || [];

      const compare = (a, b) => {
        let aVal = a[key] ?? "";
        let bVal = b[key] ?? "";

        // Profit/Loss numeric sort
        if (key === "profit_loss") {
          const numA = parseFloat(aVal) || 0;
          const numB = parseFloat(bVal) || 0;
          return direction === "asc" ? numB - numA : numA - numB;
        }

        // Date sorting
        if (key.toLowerCase().includes("date")) {
          const dateA = new Date(aVal).getTime();
          const dateB = new Date(bVal).getTime();
          return direction === "asc" ? dateA - dateB : dateB - dateA;
        }

        // General number sorting
        if (!isNaN(aVal) && !isNaN(bVal)) {
          const numA = parseFloat(aVal);
          const numB = parseFloat(bVal);
          return direction === "asc" ? numA - numB : numB - numA;
        }

        // String fallback
        return direction === "asc"
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      };

      return [...trade_search].sort(compare);
    },
    [trade_search]
  );

  // 🔹 Sorting handler
  const handleSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });

    const sorted = sortedData(key, direction);
    handlewSort?.(sorted);
  };

  // 🔹 Reusable sort icon renderer
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="sortIcon" />;
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sortIcon" />
    ) : (
      <FaSortDown className="sortIcon" />
    );
  };

  // 🔹 Column definitions (more readable, scalable)
  const columns = useMemo(() => {
    const base = [
      { key: "script_type", label: "EXCH" },
      { key: "master_username", label: "MASTER" },
      { key: "username", label: "USER" },
      { key: "symbol", label: "SYMBOL" },
      { key: "expiry_date", label: "EXPIRY" },
      { key: "qty", label: "NET QTY" },
      { key: "standing_rate", label: "OPEN" },
      { key: "rate", label: "RATE" },
      { key: "buy_sell", label: "B/S" },
      { key: "new_deposit", label: "BALANCE" },
      { key: "amount", label: "VOLUME" },
      { key: "type", label: "TYPE" },
      { key: "brokerage_user_amt", label: "COMM" },
      { key: "profit_loss", label: "P/L" },
      { key: "other", label: "OTHER" },
      { key: "date_created", label: "DATE" },
      { key: "trade_duration_minutes", label: "TIME" }
    ];

    if (trade_delete && userType === 1) {
      base.push({ key: "action", label: "ACTION" });
    }

    return base;
  }, [userType, trade_delete]);

  return (
    <div className="menuContainer primary white">
      {columns.map(({ key, label }) => (
        <div
          key={key}
          className={`menuExchange ${userType === 1 ? "small" : null} `}
          onClick={() => key !== "action" && handleSort(key)}
          style={{
            cursor: key === "action" ? "default" : "pointer",
            userSelect: "none",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {label}
          {key !== "action" && renderSortIcon(key)}
        </div>
      ))}
    </div>
  );
}
